import httpClient from '../utils/httpClient';

export const GetEmailVerify = async (userParams) => {
    const response = await httpClient.post('/user/email/verify', userParams);
    return response.data;
};

export const changePassword = async (userParams) => {
    const response = await httpClient.post('/user/password/change', userParams);
    return response.data;
};

export const uploadImageLogo = async (requestParams) => {
    const response = await httpClient.put('/user/ledger/images', requestParams);
    return response.data;
};

export const uploadProfileImage = async (requestParams) => {
    const response = await httpClient.post('/User/uploadLedgerImage', requestParams);
    return response.data;
};

